import { useState } from 'react';
import { Code, Group, Select, Text } from '@mantine/core';
import classes from './sidebar.module.css';
import { Link, useLocation } from 'react-router-dom';
import { useCenters } from '../context/CenterContext';

//  { link: '/categories', label: 'Categories'},

const data = [
  { link: '/home', label: 'Home'},
  { link: '/recipes', label: 'Recipes'},
  { link: '/operations', label: 'Sorting Operations'},
  { link: '/sorter', label: 'Sorters' },
  {link: '/categories', label: 'Categories' },
  {link: '/models', label: 'Models' },
 
];

export function NavbarSimple() {
  const [active, setActive] = useState('Home');
  const { centers, selectedCenterId, selectCenter } = useCenters();

  const centerOptions = centers.map((center) => ({
    value: String(center.id),
    label: `${center.facility_name} · ${center.name}`,
  }));

  const links = data.map((item) => (
     <Link
            key={item.label}
            to={item.link}
            className={classes.link}
            data-active={item.label === active || undefined}
            onClick={() => setActive(item.label)}
          >
      <span>{item.label}</span>
      </Link>

  ));

  return (
    <nav className={classes.navbar}>
      <div className={classes.navbarMain}>
        <div className={classes.header} >
          <Text className={classes.Medusa}>Medusa</Text>
          <Text className={classes.ByWastex}>ByWastex</Text>
          <Select
            mt="md"
            label="Center"
            placeholder={centers.length ? 'Select a center' : 'No centers with sorters'}
            data={centerOptions}
            value={selectedCenterId === null ? null : String(selectedCenterId)}
            onChange={(value) => value && selectCenter(Number(value))}
            allowDeselect={false}
            searchable
            disabled={!centers.length}
            styles={{ label: { color: '#FFF' } }}
          />
        </div>
        {links}
      </div>

    </nav>
  );
}